/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonIdentifierType } from '../../models/person-identifier-type';

export interface ConsumerValidateIdentifierPerOrganizationOrganizationIdGet$Params {
  organizationId: string;
  personIdentifierType?: PersonIdentifierType;
  identifierValue?: string;
}

export function consumerValidateIdentifierPerOrganizationOrganizationIdGet(http: HttpClient, rootUrl: string, params: ConsumerValidateIdentifierPerOrganizationOrganizationIdGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, consumerValidateIdentifierPerOrganizationOrganizationIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.query('personIdentifierType', params.personIdentifierType, {});
    rb.query('identifierValue', params.identifierValue, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as MPIStrictHttpResponse<boolean>;
    })
  );
}

consumerValidateIdentifierPerOrganizationOrganizationIdGet.PATH = '/Consumer/ValidateIdentifierPerOrganization/{organizationId}';
